import Siema from 'siema/dist/siema.min.js';

const loadCarousel = () => {
  var siemaDiv = document.querySelector('.siema');

  if (siemaDiv) {
    /*if(window.screen.width > 599) {
        var mySiema = new Siema({
        perPage: 3,
        loop: false
      });
    } else {
      var mySiema = new Siema({
        perPage: 1,
        loop: false
      });
    }*/
    if (window.screen.width > 1199) {
      var mySiema = new Siema({
        perPage: 3,
        loop: false
      });
    } else if (window.screen.width <= 1199 && window.screen.width >= 768) {
      var mySiema = new Siema({
        perPage: 2,
        loop: false
      });
    } else {
      var mySiema = new Siema({
        perPage: 1,
        loop: false
      });
    }
    const prev = document.querySelector('.social-prev');
    const next = document.querySelector('.social-next');
    prev.addEventListener('click', () => mySiema.prev());
    next.addEventListener('click', () => mySiema.next());
  }
};

export { loadCarousel };
